import { connect } from 'react-redux';
import  { selectors } from '@amplement/backend-connector';

import PreviewManager from './index';

const mapStateToProps = (state) => ({
    feedItem: state?.preview?._feedItem ? (selectors.feedItems.feedItemByIdSelector(state.preview._feedItem)(state)
        || selectors.feedItems.getLastFileFeedItems(state)?.find(x => x?.id === state.preview._feedItem)) : undefined,
});

export default connect(mapStateToProps, null)(PreviewManager);
